<template>
  <chicklet
    v-if="priority"
    :color="priority.color"
    :is-uppercase="true"
    :size="size"
    :title="priority.name"
    type="flat"
    class="priority-chicklet"
  >
    <span>
      <img v-if="showIcon" :src="selectedIcon">
      <span v-if="!iconOnly" :class="{'with-icon' : showIcon}">{{ priority.name }}</span>
    </span>
  </chicklet>
</template> 

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import LowIcon from '@/assets/img/priority/low.svg'
import MediumIcon from '@/assets/img/priority/medium.svg'
import HighIcon from '@/assets/img/priority/high.svg'
import CriticalIcon from '@/assets/img/priority/critical.svg'

/* Mixins */

/* Components */
import chicklet from './chicklet.vue'

/* Helpers */

/* Data types */
import { IDynamicObject } from '@/types'
import { IPriorityLevelForSelection } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'PriorityChicklet',

  components: {
    chicklet,
  },

  props: {
    priority: {
      type: Object as () => IPriorityLevelForSelection,
      default: null,
    },
    /* 'large', 'medium', 'small', 'tiny' */
    size: {
      type: String,
      default: 'tiny',
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    iconStatusList(): IDynamicObject {
      return {
        low: LowIcon,
        medium: MediumIcon,
        high: HighIcon,
        critical: CriticalIcon,
      }
    },
    selectedIcon(): string {
      if (this.priority.name) {
        return this.iconStatusList[this.priority.name.toLowerCase()]
      }
      return ''
    },
    showIcon(): boolean {
      return this.selectedIcon && !this.hideIcon
    },
  },
})
</script>
<style lang="scss">
.priority-chicklet {
  img {
    position: relative;
    top: -1px;
  }
  .with-icon {
    // Otherwise, the span is a little higher on the chicklet - vOv
    display: inline;
  }
}
</style>
